import { SwitchField } from "@kaltura/mediaspace-shared-ui/controlled-form";
import { SwitchesType } from "../types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

export interface SwitchesProps {
    items: SwitchesType[];
}

export function Switches(props: SwitchesProps) {
    const { items } = props;

    const sendButtonAnalytics = useButtonAnalytics();

    return (
        <>
            {items.map((item) => (
                <SwitchField
                    key={item.id}
                    id={item.id}
                    defaultValue={item.enabledByDefault}
                    onChange={(checked) =>
                        sendButtonAnalytics(
                            `Set ${item.id} - ${checked ? "enable" : "disable"}`,
                            ButtonClickAnalyticsType.TOGGLE
                        )
                    }
                    label={item.title}
                    description={item.description}
                    fontWeightBold={true}
                    isHorizontal={true}
                />
            ))}
        </>
    );
}

export default Switches;
